<template>
    <div style="height: 660px">
        <div class="about_top_parent">
            <img class="top_img" src="@/assets/img/about/about_bg.png"/>
        </div>
            <div class="about_top_desc">
                <div class="about_top_desc_title">商务合作</div>
                <div class="about_top_desc_title" style="margin-top: 10px;font-family: PingFangSC-Light, PingFang SC;"
                     v-html="cooperation"></div>
                <div style="align-self: center;margin-top:20px;font-size: 28px;font-family: PingFangSC-Light, PingFang SC;font-weight: 300;color: #3A404D;line-height: 40px;">
                    留下您的需求，我们的顾问会尽快与您联系
                </div>
                <div style="width:60%;align-self:center;display: flex;flex-direction: row">
                    <input style="flex-grow: 1;margin-right: 20px" v-model="name" placeholder="姓名"/>
                    <input style="flex-grow: 1;margin-left: 20px" v-model="phone" placeholder="电话"/>
                </div>
                <div style="position:relative;align-self: center;width:60%">
                    <textarea v-model="requireMsg" style="height:225px;width: 100%"
                              placeholder="简单描述一下您的需求，比如希望在什么场景下获取什么服务"></textarea>
                    <div class="submit" @click="submit">提交</div>
                </div>
            </div>
    </div>

</template>
<script>
    import axios from 'axios'

    export default {
        name: "Cooperation",
        data() {
            return {
                cooperation: '010-53324933    mtyy@miitang.com',
                name: '',
                phone: '',
                requireMsg: ''
            }
        },
        methods: {
            submit() {
                if (this.name === undefined || this.name === '') {
                    alert('请输入您的姓名')
                    return
                }

                if (this.phone === undefined || this.phone === '') {
                    alert('请输入您的联系方式')
                    return
                }

                var myreg = /^[1][0-9]{10}$/;
                if (!myreg.test(this.phone)) {
                    alert('手机号格式不正确')
                    return false;
                }
                var currentTime = this.currentTime();

                axios.get('https://magic.miitang.com/one.png',
                    {
                        params: {
                            name: this.name,
                            phone: this.phone,
                            require: this.requireMsg,
                            type: 'business',
                            requestTime: currentTime,
                        }
                    }).then(res => {
                    if (200 === res.status) {
                        alert('提交成功');
                    } else {
                        alert('提交失败，请重试');
                    }
                }).catch((e) => {
                    alert('提交失败，请重试');
                });
            },
            currentTime(){
                var now = new Date();
                var year = now.getFullYear();
                var month = now.getMonth() + 1;
                var day = now.getDate();
                var hh = now.getHours();
                var mm = now.getMinutes();
                var ss = now.getSeconds();
                var clock = year + "-";
                if(month < 10)
                    clock += "0";
                clock += month + "-";
                if(day < 10)
                    clock += "0";
                clock += day + " ";
                if(hh < 10)
                    clock += "0";
                clock += hh + ":";
                if (mm < 10)
                    clock += '0';
                clock += mm + ":";
                if (ss < 10)
                    clock += '0';
                clock += ss;
                return clock;
            }

        }
    }
</script>

<style scoped>

    .about_top_parent {
        position: relative;
        height: 340px;
    }

    .top_img {
        width: 100%;
        height: 340px;
    }

    .about_top_desc {
        position: relative;
        width: 100%;
        display: flex;
        margin-top: -280px;
        flex-direction: column;
        justify-content: center;
    }

    .about_top_desc_title {
        align-self: center;
        font-size: 45px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #2F2D2D;
        white-space: pre-wrap;
    }

    input, textarea {
        height: 75px;
        background: #FFFFFF;
        border-radius: 5px;
        border: 2px solid #D4D4D4;
        padding-left: 30px;
        line-height: 75px;
        font-size: 20px;
        text-align: left;
        font-family: PingFangSC-Light, PingFang SC;
        font-weight: 300;
        color: #3A404D;
        margin-top: 30px;
        box-sizing: border-box;
    }

    .submit {
        position: absolute;
        width: 100px;
        height: 44px;
        right: 30px;
        bottom: 20px;
        align-self: center;
        background: #4183D7;
        border-radius: 100px;
        font-size: 20px;
        text-align: center;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 44px;
    }

</style>